"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _styles = require("@material-ui/core/styles");
var _accent = _interopRequireDefault(require("./accent"));
var _opacity = _interopRequireDefault(require("./opacity"));
var _primary = _interopRequireDefault(require("./primary"));
var action = {
  active: _opacity["default"].black[60],
  "delete": _accent["default"].redMain,
  deleteBackgroundFocus: (0, _styles.alpha)(_accent["default"].redMain, 0.14),
  deleteBackgroundHover: (0, _styles.alpha)(_accent["default"].redMain, 0.08),
  disabled: _opacity["default"].black[38],
  disabledBackground: _opacity["default"].black[14],
  hover: _opacity["default"].black[8],
  hoverOpacity: 0.08,
  selected: (0, _styles.alpha)(_primary["default"][600], 0.14)
};
var _default = action;
exports["default"] = _default;